import {
  APPLICATION_LIST_PAGE_CHANGE,
  ASK_BEFORE_REJECT_ASSIGNMENT,
  CANCEL_OPEN_SIGN_BOX,
  CANCEL_REJECT_ASSIGNMENT,
  CLOSE_APPLICATION_PROFILE,
  CLOSE_APPLICATION_SNACKBAR,
  GET_APPLICATION_PROFILE,
  GET_APPLICATION_PROFILE_SUCCESS,
  LOCATION_CHANGE,
  OPEN_SIGN_BOX,
  REJECT_ASSIGNMENT_SUCCESS,
  SAVE_INVOICE_SUCCESS,
  SAVE_INVOICE_FAILED,
  SIGN_AND_SEND_ASSIGNMENT_FAILED,
  SIGN_AND_SEND_ASSIGNMENT_SUCCESS
} from '../constants'

const initialState = {
  signPad: false,
  assignmentWillBeSigned: [],
  assignmentWillBeRejected: [],
  openBeforeRejectDialog: false,
  applicationProfileOpen: false,
  applicationProfileData: [],
  selectedApplicationToSeeProfile: [],
  showSnackbar: false,
  showFailedSnackbar: false,
  pageSelected: 0,
  saveDraftInvoiceSuccess: false,
  saveDraftInvoiceFailed: false
}

const applicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPLICATION_LIST_PAGE_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          pageSelected: action.selected.selected
        }
      )

    case OPEN_SIGN_BOX:
      return Object.assign(
        {},
        { ...state },
        {
          assignmentWillBeSigned: action.assignmentData,
          signPad: true
        }
      )
    case CANCEL_OPEN_SIGN_BOX:
      return Object.assign(
        {},
        { ...state },
        {
          signPad: false
        }
      )
    case ASK_BEFORE_REJECT_ASSIGNMENT:
      return Object.assign(
        {},
        { ...state },
        {
          openBeforeRejectDialog: true,
          assignmentWillBeRejected: action.assignmentData
        }
      )
    case CANCEL_REJECT_ASSIGNMENT:
      return Object.assign(
        {},
        { ...state },
        {
          openBeforeRejectDialog: false
        }
      )
    case REJECT_ASSIGNMENT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          openBeforeRejectDialog: false
        }
      )
    case SIGN_AND_SEND_ASSIGNMENT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: true,
          showFailedSnackbar: false,
          signPad: false
        }
      )
    case SIGN_AND_SEND_ASSIGNMENT_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: false,
          showFailedSnackbar: true,
          signPad: false
        }
      )
    case CLOSE_APPLICATION_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: false,
          showFailedSnackbar: false,
          saveDraftInvoiceSuccess: false,
          saveDraftInvoiceFailed: false
        }
      )
    case GET_APPLICATION_PROFILE:
      return Object.assign(
        {},
        { ...state },
        {
          selectedApplicationToSeeProfile: action.values
        }
      )
    case GET_APPLICATION_PROFILE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          applicationProfileOpen: true,
          applicationProfileData: action.data
        }
      )
    case CLOSE_APPLICATION_PROFILE:
      return Object.assign(
        {},
        { ...state },
        {
          applicationProfileOpen: false
        }
      )

    case SAVE_INVOICE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          saveDraftInvoiceSuccess: true
        }
      )

    case SAVE_INVOICE_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          saveDraftInvoiceFailed: true
        }
      )

    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          signPad: false,
          applicationProfileOpen: false,
          showSnackbar: false,
          showFailedSnackbar: false,
          pageSelected: 0,
          saveDraftInvoiceSuccess: false,
          saveDraftInvoiceFailed: false
        }
      )

    default:
      return state
  }
}

export default applicationReducer
